import { render, staticRenderFns } from "./Winloss.vue?vue&type=template&id=5488e6a1"
import script from "./Winloss.vue?vue&type=script&lang=js"
export * from "./Winloss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports